const P_DROPDOWN_ITEM = "p-dropdown-item";

export const e2eTestId = {
	loginPage: {
		cookiesDialogButton: "#CybotCookiebotDialogBodyButtonDecline",
		titleText: "loginScreen-titleText",
		emailTextInput: "loginScreen-emailTextInput",
		passwordTextInput: "loginScreen-passwordTextInput",
		loginLink: "registerScreen-linkTologinPage",
		submitButton: "loginScreen-submitButton",
		redirectToSignUpButton: "loginScreen-redirectToSignUpButton",
		registerButton: "loginScreen-register",
	},
	homePage: {
		tabGetStarted: "homePage-tab-get-started",
		tabExercise: "homePage-tab-exercise",
		tabProgram: "homePage-tab-program",
		tabPatient: "homePage-tab-patient",
		tabNotifications: "homePage-tab-notifications",
		createTemplateButton: "homePage-create-template-button",
		createProgramButton: "homePage-create-program-button",
		createPatientButton: "homePage-create-patient-button",
		profileMenu: "homePage-profile-menu",
		profileMenuItem: "homePage-profile-menu-item",
	},
	createTemplatePage: {
		exerciseContainer: "exercise-container",
		headerButtonContainer: "header-button-container",
		headerBackButton: "header-back-button",
		confirmButton: "confirm-button",
		templateNameInput: "template-name-input",
		templateGrid: "template-grid",
		programGrid: "program-grid",
		arrowUp: "arrow-up",
		arrowDown: "arrow-down",
		detailField: "detail-field",
		toggleOptionButton: "ToggleOptionButton",
		builderSecondaryButton: "builder-secondary-button",
		builderPrimaryButton: "builder-primary-button",
		templateMenu: {
			goToBuilderButton: "createTemplatePage-templateMenu-goToBuilder-Button",
			deleteTemplateButton: "createTemplatePage-templateMenu-deleteTemplateButton",
		},
	},
	dialog: {
		closeButton: "p-dialog-header-close-icon",
	},
	exerciseDetailsDialog: {
		closeButton: "exerciseDetailsDialog-closeButton",
	},
	createPatientDialog: {
		consentCheckbox: "createPatientDialog-consentCheckbox",
		closeButton: "p-dialog-header-icon",
		firstNameTextInput: "createPatientDialog-firstNameTextInput",
		lastNameTextInput: "createPatientDialog-lastNameTextInput",
		dropdownFunctionalStatus: "createPatientDialog-dropdown-functional-status",
		dropdownFunctionalStatusItem: P_DROPDOWN_ITEM,
		submitButton: "createPatientDialog-submitButton",
		invitationCode: "createPatientDialog-invitation-code",
		createPatientCTA: "createPatientDialog-create-patient-cta",
	},
	patientPage: {
		ProgramTab: "patientPage-programTab",
		progressTab: "patientPage-progressTab",
		healthcareTeamTab: "patientPage-healthcareTeamTab",
		createProgramButton: "patientPage-createProgramButton",
		titreTextInput: "patientPage-titreTextInput",
		programCard: "patientPage-programCard",
	},
	scheduleProgramDialog: {
		shortcut: (index: number): string => `scheduleProgramDialog-shortcut-${index}`,
		submitButton: "scheduleProgramDialog-submitButton",
	},
	confirmActionDialog: {
		cancelButton: "confirmActionDialog-cancelButton",
		yesButton: "confirmActionDialog-yesButton",
	},
	registerPt: {
		dropdownObject: "register-pt-dropdown-object",
		dropdownObjectItem: P_DROPDOWN_ITEM,
		dropdownCountry: "register-pt-dropdown-country",
		dropdownCountryItem: P_DROPDOWN_ITEM,
		registerButton: "register-pt-register",
		nextButton: "register-pt-nex",
		emailTextInput: "register-pt-emailTextInput",
		passwordTextInput: "register-pt-passwordTextInput",
		consentCheckbox: "register-pt-consentCheckbox",
	},
	programTab: {
		programMenu: {
			goToBuilderButton: "programTab-programMenu-goToBuilder-Button",
			duplicateAsDraftButton: "programTab-programMenu-duplicateAsDraftButton",
			duplicateAsTemplateButton: "programTab-programMenu-duplicateAsTemplateButton",
			stopProgramButton: "programTab-programMenuStopProgramButton",
			deleteProgramButton: "programTab-programMenu-deleteProgramButton",
		},
	},
};
